module.exports = __webpack_public_path__ + "static/klodzko-92435c7b4c141504719dce997a1a359f.png";